module.exports = __webpack_public_path__ + "static/media/Drawer-minus.0bd0ca18.svg";